import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import { OOCPackageItemKeys } from '../../api/Constants';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import Screens from '../../screens';
import transformObjectResponseKeys from '../../utils/transformObjectResponseKeys';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import store from '../../state/store';
import initApp from '../../lib/load/initApp';
import audio from '../../utils/audio';
import { FE_SNEAK_PEEK } from '../../utils/featureFlags/constants';
import useFeatureFlags from '../../hooks/useFeatureFlags.js';
import QueryParamsProxy from '../../utils/queryParamProxy';
import { isEqual } from '../../utils/object';
import ActionsInterface from '../../api/ActionCommandsInterface';
import Emitter from '../../services/EmitterService';
import { actionCommandHandler } from '../../api/ActionCommandsInterface/utils/actionCommandHandler';
import { EVENT_EMITTER_TYPE } from '../../constants';
import getActiveRouteDescriptor from '../../utils/getActiveRouteDescriptor';
import { ACTION_COMMANDS_QUEUE } from '../../api/ActionCommandsInterface/constants';
var INIT_APP_MIN_COOLDOWN = 3600;

var LobbyOverlay = /*#__PURE__*/function (_Component) {
  function LobbyOverlay() {
    var _this2;

    _classCallCheck(this, LobbyOverlay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper2(this, LobbyOverlay, [].concat(args));
    _this2.state = {
      loading: true,
      modalsLoaded: false,
      actionCommandsFirstTime: true
    };
    _this2._checkToCallInitApp = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(new Date().getDate() !== new Date(_this2.props.lastInitApp).getDate())) {
                _context.next = 9;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return initApp.bind(_this2)();

            case 4:
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }));
    _this2.handleOnLoadModals = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this2$props$onboardi;

      var _useFeatureFlags, hasFeature, _this2$props, initAppResponse, initialModal, actionCommands, showTooltip, pendingMessages, claimPendingMessages, actionCommandsRunning, isHomeScreen, hasActionCommand, purchaseFlowPromise, i, welcomeNewsReceivedPromise, LimitedTimeOfferReceivedPromise, sneakPeekReceivedPromise, outOfCoinsResponse, promoLinks, promoLinkPromise, trigger, eventPayload;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _useFeatureFlags = useFeatureFlags(), hasFeature = _useFeatureFlags.hasFeature;
              _this2$props = _this2.props, initAppResponse = _this2$props.initAppResponse, initialModal = _this2$props.initialModal, actionCommands = _this2$props.actionCommands, showTooltip = _this2$props.showTooltip, pendingMessages = _this2$props.pendingMessages, claimPendingMessages = _this2$props.claimPendingMessages;

              if (!(initialModal === Screens.PurchaseSucceeded || initialModal === Screens.PurchaseFlow)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              actionCommandsRunning = false;
              isHomeScreen = getActiveRouteDescriptor(_this2.props).key === Screens.Home;
              hasActionCommand = actionCommands === null || actionCommands === void 0 ? void 0 : actionCommands.some(function (action) {
                return action.payload.screen === Screens.Home && action.queue === ACTION_COMMANDS_QUEUE.ENTER_LOBBY_1;
              });
              if (hasActionCommand || showTooltip) actionCommandsRunning = true;
              audio.pauseSfx();

              _this2.setState({
                loading: false
              }); //Link Account


              if (initAppResponse.SETTINGS) {
                _this2.props.isAccountLinked(initAppResponse.SETTINGS.linkedCasinoId);

                _this2.props.setCurrentMemberLevel(initAppResponse.CURRENT_MEMBER_LEVEL);
              } //Currency Selector


              if (!(initialModal === Screens.CurrencySelector && !actionCommandsRunning)) {
                _context2.next = 15;
                break;
              }

              purchaseFlowPromise = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, initialModal));
              _context2.next = 15;
              return purchaseFlowPromise;

            case 15:
              if (!(!actionCommandsRunning && initAppResponse.WELCOME && initAppResponse.WELCOME.length > 0 && isHomeScreen)) {
                _context2.next = 25;
                break;
              }

              i = 0;

            case 17:
              if (!(i < initAppResponse.WELCOME.length)) {
                _context2.next = 25;
                break;
              }

              _this2.props.setWelcomeNews(initAppResponse.WELCOME[i]);

              welcomeNewsReceivedPromise = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.News));
              _context2.next = 22;
              return welcomeNewsReceivedPromise;

            case 22:
              i++;
              _context2.next = 17;
              break;

            case 25:
              if (!(initAppResponse.LIMITED_TIME_OFFER && isHomeScreen && !actionCommandsRunning)) {
                _context2.next = 29;
                break;
              }

              LimitedTimeOfferReceivedPromise = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.LimitedTimeOffer));
              _context2.next = 29;
              return LimitedTimeOfferReceivedPromise;

            case 29:
              if (!(!actionCommandsRunning && isHomeScreen)) {
                _context2.next = 32;
                break;
              }

              _context2.next = 32;
              return _this2._shouldShowFavouritesUnlockedOnboarding();

            case 32:
              if (!(hasFeature(FE_SNEAK_PEEK) && !actionCommandsRunning && initAppResponse.SNEAK_PEEK && !((_this2$props$onboardi = _this2.props.onboardingsSeen) !== null && _this2$props$onboardi !== void 0 && _this2$props$onboardi.includes(ONBOARDING_FLOWS.SNEAK_PEEK)))) {
                _context2.next = 37;
                break;
              }

              sneakPeekReceivedPromise = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.SneakPeekOnboarding));
              _context2.next = 36;
              return sneakPeekReceivedPromise;

            case 36:
              _this2.props.markOnboardingSeen(ONBOARDING_FLOWS.SNEAK_PEEK);

            case 37:
              // Out_of_Coins
              if (initAppResponse.OUT_OF_COINS && !actionCommandsRunning) {
                outOfCoinsResponse = transformObjectResponseKeys(initAppResponse.OUT_OF_COINS, OOCPackageItemKeys);

                _this2.props.setOutOfCoinOfferResponse(outOfCoinsResponse);

                _this2.props.isOutOfCoinsPurchase(false);
              }
              /* Dev user */


              _this2.props.setIsDevUser(initAppResponse.DEV_ACCOUNT === 'yes');
              /**
               * Pending Rewards get consumed and translated into Presentable Rewards here:
               *
               * Bonus Links, Welcome Bonus, etc
               */


              if (actionCommandsRunning) {
                _context2.next = 42;
                break;
              }

              _context2.next = 42;
              return claimPendingMessages(pendingMessages);

            case 42:
              promoLinks = pendingMessages.filter(function (message) {
                return message.type === 'PROMO_LINK';
              });

              if (!(promoLinks.length > 0 && !promoLinks[0].active && !actionCommandsRunning)) {
                _context2.next = 51;
                break;
              }

              Logger.setActionTrigger('promoLink');
              promoLinkPromise = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.Shop));
              _context2.next = 48;
              return promoLinkPromise;

            case 48:
              trigger = Logger.getActionTrigger();
              eventPayload = {
                balance_before: _this2.props.coin.toString(),
                type: 'regular',
                trigger: trigger || ''
              };
              Logger.sendEvent(EVENT_TYPES.STORE_OPENED, eventPayload);

            case 51:
              !actionCommandsRunning && _this2.setState({
                modalsLoaded: true
              });

              _this2.props.setModalsLoaded(true);

            case 53:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this2.handleOnLoadActionsCommands = function (prevProps) {
      var _this2$props2 = _this2.props,
          actionCommands = _this2$props2.actionCommands,
          updatedTerms = _this2$props2.updatedTerms;
      var _this2$state = _this2.state,
          actionCommandsFirstTime = _this2$state.actionCommandsFirstTime,
          modalsLoaded = _this2$state.modalsLoaded;
      var prevScreen = getActiveRouteDescriptor(prevProps).key;
      var currentScreen = getActiveRouteDescriptor(_this2.props).key;
      var propsChanged = !isEqual(prevProps.actionCommands, actionCommands) || !isEqual(prevScreen, currentScreen) || actionCommandsFirstTime;
      var hasActionCommands = actionCommands.length > 0 && actionCommands.some(function (action) {
        return action.queue === ACTION_COMMANDS_QUEUE.ENTER_LOBBY_1;
      });
      var shouldHandleActionCommands = propsChanged && !updatedTerms && (hasActionCommands || modalsLoaded);

      if (shouldHandleActionCommands) {
        _this2.setState({
          actionCommandsFirstTime: false
        });

        ActionsInterface(_this2.props);
      }
    };

    _this2._shouldShowFavouritesUnlockedOnboarding = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this2$props3, onboardingsSeen, userLevel, onboardingsUnlockLevels, favouriteGames, dynamicTriggeredUnlockedFavourites;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this2$props3 = _this2.props, onboardingsSeen = _this2$props3.onboardingsSeen, userLevel = _this2$props3.userLevel, onboardingsUnlockLevels = _this2$props3.onboardingsUnlockLevels, favouriteGames = _this2$props3.favouriteGames;

              if (!(!(onboardingsSeen !== null && onboardingsSeen !== void 0 && onboardingsSeen.includes(ONBOARDING_FLOWS.FAVOURITES)) && userLevel === onboardingsUnlockLevels[ONBOARDING_FLOWS.FAVOURITES] && favouriteGames.gameList.length === 0)) {
                _context3.next = 5;
                break;
              }

              dynamicTriggeredUnlockedFavourites = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.FavouritesUnlocked));
              _context3.next = 5;
              return dynamicTriggeredUnlockedFavourites;

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    _this2._menuChangeHandler = function (id) {
      QueryParamsProxy.navigate(_this2.props.navigation, id);
    };

    _this2._tooltipButtonClickHandler = function (buttonAction) {
      var _QueryParamProxy$setQ7;

      audio.onClick();
      QueryParamProxy.setQueryParams((_QueryParamProxy$setQ7 = {}, _defineProperty(_QueryParamProxy$setQ7, RouteParamConstants.PARAM_MODAL, buttonAction.modal), _defineProperty(_QueryParamProxy$setQ7, RouteParamConstants.PARAM_SHOP_TYPE, buttonAction.type), _QueryParamProxy$setQ7));

      _this2.props.shouldShowTooltip(false);
    };

    _this2._dismissModal = function () {
      _this2.props.setModal(null);

      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
    };

    return _this2;
  }

  _inherits(LobbyOverlay, _Component);

  return _createClass(LobbyOverlay, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.props.token === '')) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                if (!(new Date().getTime() - this.props.lastInitApp > INIT_APP_MIN_COOLDOWN)) {
                  _context4.next = 13;
                  break;
                }

                _context4.prev = 3;
                _context4.next = 6;
                return initApp.bind(this)();

              case 6:
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](3);
                console.error(_context4.t0);

              case 11:
                _context4.next = 14;
                break;

              case 13:
                this.synchronizeLobby(this.props, this.state);

              case 14:
                this.setState({
                  loading: false
                });
                Emitter.on(EVENT_EMITTER_TYPE.ACTION_COMMANDS, function (_ref4) {
                  var actionType = _ref4.actionType,
                      data = _ref4.data;
                  return actionCommandHandler[actionType](data);
                });

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 8]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Emitter.off(EVENT_EMITTER_TYPE.ACTION_COMMANDS);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!isEqual(prevProps, this.props)) this.synchronizeLobby(prevProps, prevState);
      if (!isEqual(prevProps.initAppResponse, this.props.initAppResponse) || !isEqual(prevProps.actionCommands, this.props.actionCommands) && !this.state.modalsLoaded) this.handleOnLoadModals();
      if (this.state.modalsLoaded && this.props.pendingMessages.length > prevProps.pendingMessages.length) this.props.claimPendingMessages(this.props.pendingMessages);
      this.handleOnLoadActionsCommands(prevProps);
    }
  }, {
    key: "synchronizeLobby",
    value: function () {
      var _synchronizeLobby = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(prevProps) {
        var _this$props, navigation, descriptors, activeKey, descriptor, prevActiveKey, prevDescriptor, connectionLostModal, cheatMenuActive, eventPayload;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!store.getState().device.isConnected) {
                  _context5.next = 14;
                  break;
                }

                _this$props = this.props, navigation = _this$props.navigation, descriptors = _this$props.descriptors;
                activeKey = navigation.state.routes[navigation.state.index].key;
                descriptor = descriptors[activeKey];
                prevActiveKey = prevProps.navigation.state.routes[prevProps.navigation.state.index].key;
                prevDescriptor = prevProps.descriptors[prevActiveKey]; // coming back from a 'not connected' error?

                connectionLostModal = QueryParamProxy.findParam(RouteParamConstants.PARAM_MODAL, false); // coming from the cheat menu?

                cheatMenuActive = QueryParamProxy.findParam(RouteParamConstants.PARAM_CHEAT_MENU_ACTIVE, false);

                if (connectionLostModal === Screens.ConnectionLost && !cheatMenuActive) {
                  QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
                }

                if (!(prevDescriptor.key != Screens.Home && prevDescriptor.key != descriptor.key)) {
                  _context5.next = 12;
                  break;
                }

                _context5.next = 12;
                return this._shouldShowFavouritesUnlockedOnboarding();

              case 12:
                _context5.next = 17;
                break;

              case 14:
                // need to inform the user that the connection has been lost
                QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.ConnectionLost));
                eventPayload = {
                  description: 'This app is currently not available.',
                  code: 4
                };
                Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function synchronizeLobby(_x) {
        return _synchronizeLobby.apply(this, arguments);
      }

      return synchronizeLobby;
    }()
  }, {
    key: "render",
    value: function render() {
      return this.props.render(_objectSpread(_objectSpread({}, this.props), {}, {
        descriptor: getActiveRouteDescriptor(this.props),
        loading: this.state.loading,
        menuChangeHandler: this._menuChangeHandler,
        modal: this.props.modal.modal ? this.props.modal.modal : null,
        dismissModal: this._dismissModal,
        tooltipButtonClickHandler: this._tooltipButtonClickHandler,
        checkToCallInitApp: this._checkToCallInitApp
      }));
    }
  }]);
}(Component);

export { LobbyOverlay as default };